module.exports = __webpack_public_path__ + "img/3-3.2363db36.png";